import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function HowItWorks() {
  const steps = [
    { n: "01", t: "Sign up in seconds", d: "Create a free account with your email. No credit card required." },
    { n: "02", t: "Tell us where you live", d: "Choose Australia, Canada or the UK. We'll tailor the English variant to match." },
    { n: "03", t: "Set your goal", d: "Workplace, everyday, healthcare, housing, interviews — pick what matters most." },
    { n: "04", t: "Take a short assessment", d: "Eight quick questions estimate your practice level." },
    { n: "05", t: "Follow your plan", d: "Short lessons plus real-life scenarios you actually face." },
    { n: "06", t: "Review your mistakes", d: "The Mistake Bank turns recurring mistakes into focused practice." },
  ];
  return (
    <div>
      <section className="rle-gradient-bg py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <span className="rle-eyebrow">How it works</span>
          <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl text-slate-900">Six simple steps to real-life English.</h1>
          <p className="mt-4 text-lg text-slate-600">A structured path — not a random chatbot.</p>
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 space-y-4">
          {steps.map((s) => (
            <div key={s.n} className="rle-card p-6 flex gap-6 items-start" data-testid={`step-${s.n}`}>
              <div className="font-mono text-emerald-700 font-semibold">{s.n}</div>
              <div>
                <h3 className="font-display font-bold text-lg text-slate-900">{s.t}</h3>
                <p className="text-slate-600 mt-1">{s.d}</p>
              </div>
              <CheckCircle2 className="ml-auto text-emerald-700" size={20}/>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link to="/register"><Button className="rounded-full bg-emerald-700 hover:bg-emerald-800 h-12 px-6" data-testid="hiw-cta-btn">Start Learning Free</Button></Link>
        </div>
      </section>
    </div>
  );
}
